import validate from "/builds/application/sim-portal/monorepo/node_modules/.pnpm/nuxt@3.21.9_@parcel+watcher@2.5.6_@types+node@22.10.7_@vue+compiler-sfc@3.5.40_cac@6.7._c7871f915bcfe8c7b3e96b0e7d14a624/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/builds/application/sim-portal/monorepo/apps/frontend/middleware/auth.global.ts";
import manifest_45route_45rule from "/builds/application/sim-portal/monorepo/node_modules/.pnpm/nuxt@3.21.9_@parcel+watcher@2.5.6_@types+node@22.10.7_@vue+compiler-sfc@3.5.40_cac@6.7._c7871f915bcfe8c7b3e96b0e7d14a624/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}